var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 131,
    viewBox: "0 0 128 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67.0149,
    width: 90.0453,
    height: 90.0453,
    rx: 37,
    transform: "rotate(-45 0 67.0149)",
    fill: "#000466",
    fillOpacity: 0.69
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.254 52C102.73 52 101.269 52.6033 100.191 53.677C99.1137 54.7508 98.5083 56.2072 98.5083 57.7258V86.087L76.5453 75.0636V57.7258C76.4068 56.2958 75.7388 54.9686 74.6715 54.0028C73.6043 53.037 72.2143 52.502 70.7727 52.502C69.331 52.502 67.9411 53.037 66.8738 54.0028C65.8066 54.9686 65.1386 56.2958 65 57.7258V110.274C65.1386 111.704 65.8066 113.031 66.8738 113.997C67.9411 114.963 69.331 115.498 70.7727 115.498C72.2143 115.498 73.6043 114.963 74.6715 113.997C75.7388 113.031 76.4068 111.704 76.5453 110.274V83.4114L97.6492 94.0067L98.5083 94.2743V110.274C98.5083 111.793 99.1137 113.249 100.191 114.323C101.269 115.397 102.73 116 104.254 116C105.013 116.007 105.766 115.864 106.47 115.58C107.173 115.295 107.813 114.874 108.352 114.342C108.891 113.81 109.319 113.176 109.611 112.478C109.903 111.78 110.054 111.031 110.054 110.274V57.7258C110.054 56.9693 109.903 56.2204 109.611 55.5222C109.319 54.824 108.891 54.1904 108.352 53.658C107.813 53.1256 107.173 52.705 106.47 52.4204C105.766 52.1358 105.013 51.9929 104.254 52Z",
    fill: "#C48C2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_154_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6443 38.4267L51.4815 32.9974L45.4725 10.999C44.8574 9.37751 43.6627 8.04284 42.1214 7.25522C40.5801 6.4676 38.8026 6.2835 37.1357 6.73885C35.4687 7.1942 34.0317 8.25634 33.1048 9.71816C32.178 11.18 31.8277 12.9366 32.1224 14.6457L35.6801 27.6702L16.8563 21.2935C15.6882 21.0085 14.4561 21.1961 13.4266 21.8158C12.397 22.4354 11.6528 23.4372 11.3549 24.6044C11.0733 25.7654 11.2618 26.9918 11.879 28.0155C12.4963 29.0391 13.4921 29.7767 14.6486 30.0667L38.5399 38.1397L48.8386 75.8423C49.4537 77.4638 50.6484 78.7985 52.1897 79.5861C53.731 80.3738 55.5085 80.5579 57.1754 80.1025C58.8424 79.6472 60.2794 78.585 61.2063 77.1232C62.1331 75.6614 62.4834 73.9047 62.1887 72.1957L54.3413 43.4669L65.4367 47.1999C66.6047 47.4849 67.8368 47.2973 68.8664 46.6777C69.896 46.0581 70.6402 45.0562 70.938 43.889C71.0864 43.3139 71.1185 42.7146 71.0325 42.1264C70.9465 41.5381 70.7441 40.9729 70.4371 40.4639C70.1302 39.9549 69.725 39.5125 69.2454 39.1626C68.7658 38.8128 68.2214 38.5626 67.6443 38.4267Z",
    fill: "#C48C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 64,
    fill: "white",
    transform: "translate(65 52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_154_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.49,
    height: 77.2634,
    fill: "white",
    transform: "translate(7.88519 14.1006) rotate(-15.278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2);
export default __webpack_public_path__ + "static/media/sec2.6030abb233be5d7cddab1316bb9978f4.svg";
export { ForwardRef as ReactComponent };